import { expenseDateValidation } from "../../../../utils/validation/expenseDateValidation";
import * as Yup from "yup";
import {
  AmountRequired,
  CategoryRequired,
  DateRequired,
  DescriptionRequired,
  PaymentModeRequired,
} from "../../../../utils/Constant";
import { fileValidationSchema, requiredString } from "../../../../utils/validation/comonValidation";


export const pettyCashExpenseValidationSchema = Yup.object()?.shape({
  categoryType: requiredString(CategoryRequired),
  amount: requiredString(AmountRequired),
  paymentMode: requiredString(PaymentModeRequired),
  pettyCashDate: expenseDateValidation(DateRequired, "Invalid date format"),
  description: requiredString(DescriptionRequired),
  pettyCashAttachment: fileValidationSchema,
});
